import {
  FIRST_SUPPORTED_ONBOARDING_TODO_YEAR,
  LAST_SUPPORTED_ONBOARDING_TODO_YEAR
} from "../Todos.constants";
import { getAllOnboardingTodoLabelsForYear } from "./getAllOnboardingTodoLabelsForYear";

export function getAllPossibleOnboardingTodoLabels() {
  const labels: Array<string> = [];

  for (
    let year = FIRST_SUPPORTED_ONBOARDING_TODO_YEAR;
    year < LAST_SUPPORTED_ONBOARDING_TODO_YEAR + 1;
    year++
  ) {
    labels.push(...getAllOnboardingTodoLabelsForYear(year));
  }

  const uniqueLabels = Array.from(new Set(labels));

  return uniqueLabels;
}
